import { pipeline, env } from '@huggingface/transformers';
import { debug } from './debug';

// Configure transformers.js to use local models
env.allowLocalModels = false;
// Use single-threaded WASM to avoid cross-origin isolation requirements
env.backends.onnx.wasm.numThreads = 1;

let featureExtractor: any = null;

export async function initializeCLIP() {
  if (!featureExtractor) {
    debug.log('Loading CLIP model...');
    featureExtractor = await pipeline(
      'image-feature-extraction',
      'Xenova/clip-vit-base-patch32',
      {
        revision: 'main',
      }
    );
    debug.log('CLIP model loaded');
  }
  return featureExtractor;
}

export async function generateImageEmbedding(imageUrl: string): Promise<number[]> {
  const extractor = await initializeCLIP();

  // Generate embedding directly from URL
  const output = await extractor(imageUrl, {
    pooling: 'mean',
    normalize: true,
  });

  // Convert to array regardless of output shape
  const raw = (output as any)?.data ?? output;
  const embedding: number[] = Array.isArray(raw)
    ? (Array.isArray(raw[0]) ? (raw[0] as number[]) : (raw as number[]))
    : Array.from(raw);
  
  return embedding;
}

export function cosineSimilarity(vec1: number[], vec2: number[]): number {
  if (vec1.length !== vec2.length) {
    throw new Error('Vectors must have the same dimension');
  }
  
  let dotProduct = 0;
  let norm1 = 0;
  let norm2 = 0;
  
  for (let i = 0; i < vec1.length; i++) {
    dotProduct += vec1[i] * vec2[i];
    norm1 += vec1[i] * vec1[i];
    norm2 += vec2[i] * vec2[i];
  }
  
  return dotProduct / (Math.sqrt(norm1) * Math.sqrt(norm2));
}
